/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/base-action.type';
import * as actions from '../../types/companies-action.type';

export type CompaniesState = {
  data: Array<any> | undefined,
  isSetting: boolean,
  error?: any,
  isEmptyData: boolean,
};

const initialState: CompaniesState = {
  data: undefined,
  isSetting: false,
  error: null,
  isEmptyData: false,
}

export const companiesReducer = (
  state: CompaniesState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.GET_COMPANIES:
      return {...state, isSetting: true, error: null, isEmptyData: false }
    case actions.GET_COMPANIES_SUCCESS:
      return {...state, ...action.payload, error: null, isSetting: false}
    case actions.GET_COMPANIES_ERROR:
      return {...state, error: action.payload, isSetting: false, isEmptyData: false}
    default:
      return state;
  }
};
